export const MESSAGE_REQUESTS_FLAG_NAME =
  process.env.NEXT_PUBLIC_MESSAGE_REQUESTS_FLAG ||
  process.env.EXPO_PUBLIC_MESSAGE_REQUESTS_FLAG ||
  "message-requests-dev"
